import type { SLO, HealthReport, Service } from "@coremonit/types";
import { makeRng, int } from "./rng";

export function slosFor(s: Service, seed = 42): SLO[] {
  const rng = makeRng(seed + s.id.length);
  const total = 1_000_000;
  const good  = Math.floor(total * s.availabilityPct / 100);
  return [
    { id: `slo_${s.id}_avail`, serviceId: s.id, name: "Availability",     targetPct: 99.9, currentPct: s.availabilityPct, errorBudgetPct: +((s.availabilityPct - 99.9) * 10).toFixed(1),  window: "30d", sli: { good, total } },
    { id: `slo_${s.id}_lat`,   serviceId: s.id, name: "p95 latency < 500ms", targetPct: 99, currentPct: 100 - Math.min(30, s.latencyP95Ms / 40), errorBudgetPct: 0.42, window: "30d", sli: { good: total - int(rng, 100, 5000), total } },
    { id: `slo_${s.id}_err`,   serviceId: s.id, name: "Error rate < 1%",  targetPct: 99, currentPct: 100 - s.errorRatePct * 3, errorBudgetPct: 0.18, window: "30d", sli: { good: total - int(rng, 200, 6000), total } },
  ];
}

export function healthFor(s: Service): HealthReport {
  const availabilityScore = Math.round(Math.max(0, Math.min(100, (s.availabilityPct - 99) * 100)));
  const latencyScore      = Math.round(Math.max(0, 100 - s.latencyP95Ms / 12));
  const errorScore        = Math.round(Math.max(0, 100 - s.errorRatePct * 12));
  const trafficScore      = Math.round(Math.min(100, s.requestsPerMin / 60));
  const saturationScore   = Math.round(Math.max(30, 100 - s.oomKills24h * 12 - s.restarts24h * 3));
  const deploymentScore   = s.status === "critical" ? 40 : s.status === "warning" ? 72 : 92;
  const dependencyScore   = s.tags.includes("critical") ? 76 : 88;
  const aiScore = Math.round(
    (availabilityScore * 0.25 + latencyScore * 0.2 + errorScore * 0.2 + trafficScore * 0.1 +
     saturationScore * 0.1 + deploymentScore * 0.1 + dependencyScore * 0.05)
  );
  return {
    serviceId: s.id,
    aiScore: Math.max(0, Math.min(100, aiScore)),
    availabilityPct: s.availabilityPct,
    latencyScore, errorScore, trafficScore, saturationScore,
    deploymentScore, dependencyScore,
    slos: slosFor(s),
  };
}
